"use client";

import NextError from "next/error";
import { useEffect } from "react";
import { addDatadogError } from "@/utils/datadog";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Track error in Datadog RUM
    addDatadogError(error, {
      source: 'global-error-boundary',
      tags: { digest: error.digest || 'unknown' },
    });
    console.error("Global error:", error);
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
